<template>
  <transition name="modal">
    <div class="modal-mask" @click.self="hide">
      <div class="modal-wrapper" @click.self="hide">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class='modal-header'>
              <button v-if='config.show_close_btn' class='modal__close-btn' @click="hide">
                <i class='kf kf-x'></i>
                <div class='sr-only'>{{Kadenze.I18n.t('dict.close')}}</div>
              </button>
              <h4 class="modal-title">{{modal_title}}</h4>
              <p class='mt0' v-if='modal_description'>{{modal_description}}</p>
              <hr v-if='config.underline_header'/>
            </div>
            <div class='modal-body'>
              <!-- Icon based -->
              <!-- <div class='center txt-c'>
                <div class='modal-share__icon kf-stack kf-stack--circle' aria-hidden='true'>
                  <i class='kf kf-circle-outline'></i>
                  <i class='kf kf-share'></i>
                </div>
                <h4 class='modal-confirmation__title mt0'>{{modal_title}}</h4>
                <p class='bold mt0' v-if='modal_description'>{{modal_description}}</p>
              </div> -->
              
              <!-- Non-icon based -->
              <!-- content slot -->
              <slot name="body" />
            </div>
              
            <div v-if='config.use_template_footer' class='modal-footer'>
              <!-- footer slot -->
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      modal_title: {
        type: String,
        required: true
      },
      modal_description: {
        type: String
      },
      config: {
        type: Object,
        default: function() {
          return {
            underline_header: false,
            show_close_btn: true,
            use_template_footer: true
          }
        }
      }
    },
    methods: {
      hide() {
        this.$emit('close');
      },
    }
  }
</script>
